module.exports = __webpack_public_path__ + "img/pic_feature_01.b02a6c57.jpg";